// src/components/forum/Navbar.jsx
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { AnimatePresence, motion } from 'framer-motion';
import logo from '../../assets/images/WriteApp.png';

const SidebarMobile = ({ onClose, currentPage, user, logout, navigate }) => {
  const handleLogout = () => {
    logout();
    onClose();
    navigate('/');
  };

  useEffect(() => {
    console.log(user);
  }, []);

  return (
    <motion.aside
      initial={{ x: '-100%' }}
      animate={{ x: 0 }}
      exit={{ x: '-100%' }}
      transition={{ type: 'spring', stiffness: 100, damping: 20 }}
      className="fixed inset-y-0 left-0 z-50 w-64 bg-[#111] border-r border-gray-800 flex flex-col justify-between"
    >
      <button
        onClick={onClose}
        className="self-end m-4 p-2 text-gray-400 hover:text-white focus:outline-none"
      >
        ×
      </button>

      <div className="px-6 mb-6">
        <Link to="/forum" onClick={onClose} className="flex items-center gap-3">
          <img src={logo} alt="WriteApp Logo" className="h-8 w-auto" />
        </Link>
      </div>

      <nav className="flex-1 px-4 space-y-2">
        {[
          { to: '/forum', label: 'Forum', key: 'forum' },
          { to: '/blog', label: 'Blogs', key: 'blog' },
          { to: '/about', label: 'About', key: 'about' },
        ].map(({ to, label, key }) => (
          <Link
            key={key}
            to={to}
            onClick={onClose}
            className={`block px-3 py-2 rounded ${currentPage === key ? 'bg-gray-800 text-white' : 'text-gray-300 hover:bg-gray-800'
              }`}
          >
            {label}
          </Link>
        ))}
      </nav>

      <div className="px-4 mb-6">
        {user ? (
          <>
            <Link
              to="/profile/me"
              onClick={onClose}
              className="flex items-center py-2 rounded text-gray-300 hover:bg-gray-800"
            >
              <span className="ml-3">Your profile</span>
            </Link>
            <button
              onClick={handleLogout}
              className="w-full text-left mt-2 px-3 py-2 rounded text-gray-300 hover:bg-gray-800"
            >
              Logout
            </button>
          </>
        ) : (
          <Link
            to="/login"
            onClick={onClose}
            className="block px-3 py-2 rounded text-gray-300 hover:bg-gray-800"
          >
            Login
          </Link>
        )}
      </div>
    </motion.aside>
  );
};

const Navbar = ({ currentPage }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.paddingTop = '64px';
    return () => {
      document.body.style.paddingTop = '0px';
    };
  }, []);

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-40 px-6 py-4 bg-black/30 backdrop-blur-lg shadow-md h-16">
        <div className="flex justify-between items-center h-full">
          <Link to="/" className="flex items-center gap-3">
            <img src={logo} alt="WriteApp Logo" className="h-12 w-auto" />
          </Link>

          <nav className="hidden md:flex items-center gap-6">
            <Link
              to="/forum"
              className={`text-sm ${currentPage === 'forum'
                  ? 'text-primary font-medium'
                  : 'text-gray-400 hover:text-white'
                }`}
            >
              Forum
            </Link>
            <Link
              to="/blog"
              className={`text-sm ${currentPage === 'blog'
                  ? 'text-primary font-medium'
                  : 'text-gray-400 hover:text-white'
                }`}
            >
              Blogs
            </Link>
            <Link
              to="/about"
              className={`text-sm ${currentPage === 'about'
                  ? 'text-primary font-medium'
                  : 'text-gray-400 hover:text-white'
                }`}
            >
              About
            </Link>
            {user ? (
              <Link to="/profile/me" className="text-sm text-gray-400 hover:text-white">
                Profile
              </Link>
            ) : (
              <Link to="/login" className="text-sm text-gray-400 hover:text-white">
                Login
              </Link>
            )}
          </nav>

          <button
            onClick={() => setDrawerOpen(true)}
            className="hamburger-icon md:hidden text-gray-300 focus:outline-none"
          >

            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
        </div>
      </header>

      <AnimatePresence>
        {drawerOpen && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.5 }}
              exit={{ opacity: 0 }}
              onClick={() => setDrawerOpen(false)}
              className="fixed inset-0 bg-black z-40"
            />
            <SidebarMobile
              onClose={() => setDrawerOpen(false)}
              currentPage={currentPage}
              user={user}
              logout={logout}
              navigate={navigate}
            />
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;